// @flow

import boards from 'app/common/redux/middleware/boards';
import contextLog from 'app/common/redux/middleware/contextLog';
import errorLog from 'app/common/redux/middleware/errorLog';
import experiences from 'app/common/redux/middleware/experiences';
import resourceFetch from 'app/common/redux/middleware/resourceFetch';
import thunk from 'redux-thunk';
import { applyMiddleware } from 'redux';

const middlewares = [thunk, boards, contextLog, errorLog, experiences, resourceFetch];

// $FlowFixMe: new errors found from flow 0.96 upgrade
export default () => applyMiddleware(...middlewares);
